import axios from 'axios';
import { locale } from 'common/utils/helpers';

export const getCategories = () =>
  axios.get(`/meta/faq/category/list/admin/`, {
    headers: {
      locale,
    },
  });

export const getQuestions = id =>
  axios.get(`/meta/faq/category/${id}/`, {
    headers: {
      locale,
    },
  });
